import Vue from 'vue';
import "vanilla-cookieconsent/dist/cookieconsent.css";
import * as CookieConsent from "vanilla-cookieconsent";

import sr from 'static/locales/sr.json';
import en from 'static/locales/en.json';
import de from 'static/locales/de.json';
import { addSportradarTag, removeSportradarTag } from "./sportradar";

// You can see other options here: https://playground.cookieconsent.orestbida.com/
// You can also download a new configuration from there and replace the one below.
// I borrowed some of the terminology from https://www.termsfeed.com/cookie-consent
const pluginConfig = {
	guiOptions: {
		consentModal: {
			layout: "box inline",
			position: "bottom right",
			equalWeightButtons: true,
			flipButtons: false
		},
		preferencesModal: {
			layout: "box",
			position: "right",
			equalWeightButtons: true,
			flipButtons: false
		}
	},
	categories: {
		necessary: {
			readOnly: true
		},
		functionality: {},
		analytics: {},
		marketing: {}
	},
	language: {
		default: "de",
		autoDetect: "document",
		translations: {
			de,
			en,
			sr
		}
	},
	onFirstConsent: ({ cookie }) => {
		configureClarityConsent(cookie);
		configureGoogleConsent(cookie);
		configureSportradarConsent(cookie);
		configureMetaPixelConsent(cookie);
	},
	onChange: ({ cookie }) => {
		configureClarityConsent(cookie);
		configureGoogleConsent(cookie);
		configureSportradarConsent(cookie);
		configureMetaPixelConsent(cookie);
	},
	onConsent: ({ cookie }) => {
		configureClarityConsent(cookie);
		configureGoogleConsent(cookie);
		configureSportradarConsent(cookie);
		configureMetaPixelConsent(cookie);
	}
}

function configureClarityConsent(cookie) {
	if (!window.clarity) {
		setTimeout(() => configureClarityConsent(cookie), 1000);
		return;
	}

	const consent = {
		ad_Storage: "denied",
		analytics_Storage: "denied"
	}

	if (cookie.categories.includes("analytics")) {
		consent.analytics_Storage = "granted";
	}

	if (cookie.categories.includes("marketing")) {
		consent.ad_Storage = "granted";
	}

	// You can use  clarity('metadata', (d, upgrade, consent) => {
	//   console.log('consentStatus:', consent);
	// }, false, true, true);
	// in the console to see what is happening

	// We use this to configure Microsoft Clarity consent
	// The v2 API is not yet present in the official package
	window.clarity('consentv2', consent);
}

window.dataLayer = window.dataLayer || [];
function gtag() { window.dataLayer.push(arguments); }

function configureGoogleConsent(cookie) {
	const consent = {
		ad_user_data: 'denied',
		ad_personalization: 'denied',
		ad_storage: 'denied',
		analytics_storage: 'denied'
	}

	if (cookie.categories.includes("analytics")) {
		consent.analytics_storage = "granted";
	}

	if (cookie.categories.includes("marketing")) {
		consent.ad_user_data = "granted";
		consent.ad_personalization = "granted";
		consent.ad_storage = "granted";
	}

	gtag('consent', 'update', consent);
}

function configureSportradarConsent(cookie) {
	if (cookie.categories.includes("marketing")) {
		addSportradarTag();
	} else {
		removeSportradarTag();
	}
}

function configureMetaPixelConsent(cookie) {
	const fb = window.$nuxt?.$fb;
	if (!fb) {
		return;
	}

	// Disable only: re-enabling needs the organizer's pixel id, which setupMetaPixel supplies
	if (!cookie.categories.includes("marketing")) {
		fb.disable();
	}
}

const cookieConsentPlugin = {
	install: (_app) => {
		Vue.prototype.$CookieConsent = CookieConsent;
		Vue.prototype.$CookieConsent.run(pluginConfig);
	}
}
export default cookieConsentPlugin;

Vue.use(cookieConsentPlugin);